import { ArrowLeftCircle } from "react-bootstrap-icons";
import { Link } from "react-router-dom";

interface BackToUsersButtonProps {
  // Ask before leaving, e.g. while a form has unsaved changes.
  confirmLeave?: boolean;
}

const BackToUsersButton: React.FC<BackToUsersButtonProps> = ({ confirmLeave = false }) => (
  <Link
    to="/admin/users"
    aria-label="Back to Users"
    className="d-inline-flex text-dark"
    onClick={(event) => {
      if (confirmLeave && !window.confirm("Discard unsaved changes?")) event.preventDefault();
    }}
  >
    <ArrowLeftCircle size={28} />
  </Link>
);

export default BackToUsersButton;
